import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

interface IconLoadingLineProps extends IconProps {
  spin?: boolean;
}

const IconLoadingLine = ({
  width,
  height,
  fill = 'currentColor',
  spin = false,
  style,
  ...props
}: IconLoadingLineProps) => {
  const spinAnimation = spin
    ? {
        animation: 'spin 1s linear infinite',
      }
    : {};

  return (
    <>
      {spin && (
        <style>
          {`
            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
          `}
        </style>
      )}
      <Svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        style={{ ...spinAnimation, ...style }}
        {...props}
      >
        <path d="M11.997 21.5a9.22 9.22 0 0 1-3.683-.747 9.628 9.628 0 0 1-3.026-2.041 9.629 9.629 0 0 1-2.04-3.026 9.198 9.198 0 0 1-.748-3.683c0-1.316.25-2.55.749-3.7a9.66 9.66 0 0 1 2.04-3.015A9.625 9.625 0 0 1 8.314 3.25 9.203 9.203 0 0 1 12 2.5c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534.722.722 0 0 1-.216.534A.726.726 0 0 1 12 4c-2.217 0-4.104.78-5.662 2.338C4.779 7.896 4 9.783 4 12s.78 4.104 2.338 5.663C7.896 19.22 9.783 20 12 20s4.104-.78 5.663-2.337C19.22 16.104 20 14.217 20 12c0-.213.072-.391.216-.534a.726.726 0 0 1 .534-.216c.213 0 .391.072.535.216A.725.725 0 0 1 21.5 12c0 1.3-.25 2.528-.749 3.685a9.625 9.625 0 0 1-2.04 3.027 9.66 9.66 0 0 1-3.015 2.039c-1.15.5-2.383.749-3.699.749Z" />
      </Svg>
    </>
  );
};

export default IconLoadingLine;
